var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCollaboratorsi = function SvgCollaboratorsi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M21.36 18.81a9.15 9.15 0 0 0-4.8-6.1 6.23 6.23 0 0 0 2.08-4.62A6.52 6.52 0 0 0 12 1.71 6.52 6.52 0 0 0 5.36 8.1a6.23 6.23 0 0 0 2.08 4.62 9.15 9.15 0 0 0-4.8 6.1 2.79 2.79 0 0 0 .6 2.41 3.05 3.05 0 0 0 2.33 1.07h12.86a3.05 3.05 0 0 0 2.33-1.07 2.79 2.79 0 0 0 .6-2.4zM12 4.6a3.58 3.58 0 0 1 3.64 3.5A3.58 3.58 0 0 1 12 11.6a3.58 3.58 0 0 1-3.64-3.5A3.58 3.58 0 0 1 12 4.6M5.57 19.4A6.5 6.5 0 0 1 12 14.47a6.5 6.5 0 0 1 6.43 4.93z",
    "data-name": "Path 4862"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCollaboratorsi);
export default ForwardRef;